RivalIQ.module('landscape.views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    views.CompanyAddTileItem = Marionette.ItemView.extend({
        ui: {
            innerPart: '.x-inner'
        },
        tagName: 'li',
        template: '#companyAddTileItemTemplate',
        templateHelpers: function () {

            const me = this;
            const data = me.model.toJSON();

            const result = {
                imgSrc: RivalIQ.utils.companyDisplay.getIcon(data),
                abbr: RivalIQ.utils.companyDisplay.getAbbreviation(data)
            };

            return result;
        },
        onRender: function () {

            const me = this;
            me.ui.innerPart.fadeIn(1000);
        }
    });

});
